export default __webpack_public_path__ + "static/tanulo_4-1cb4bad50d74b9958d923ce16618c951.webp";